/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BillingRawUsageStateEnum } from './billingRawUsageStateEnum';


export interface BillingRawUsagePostSpec { 
    entity_id?: number;
    org_id?: string;
    state?: BillingRawUsageStateEnum;
    data_center?: string;
    extrapolated?: boolean;
    info?: string;
    metric_info_id?: number;
    usage_json?: string;
    usage_ts?: Date;
}
export namespace BillingRawUsagePostSpec {
}


